import { accessRole } from '../../../../../helpers/access_role'
import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import apiResponse from '../../../../../services/apiResponse'

import ApproveBloc from './Blocs/ApproveBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar';
import moment from 'moment';

import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'

class IndexView extends Component {

    approveBloc = new ApproveBloc()
    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_name = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_full_name : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_full_name : "")
    employee_current_position_name = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_current_position_name : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_current_position_name : "")

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionStatusApproval : [
              { label: "Disetujui", value: 1 },
              { label: "Ditolak", value: 2 }
            ],
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    submitData = async () => {
        await this.approveBloc.fetchApprove(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              uuid: this.state.detail.family_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.approveBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_current = result.data.response.current
                        let response_history = result.data.response.history
                        this.setState({
                            detail: response_current,
                            dataForm: {
                              status: 1,
                              uuid : response_current.family_uuid
                            },
                            history: response_history
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.approveBloc.fetchDetail({uuid: queryParams.get('uuid'), history:1 })

        /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
        try {
            let causer = queryParams.get('causer')

            if (causer != null){
                let arrCauser = atob(causer).split('|');
    
                let dataUser = {
                    employee_uuid: arrCauser[1],
                    employee_name : arrCauser[0],
                    employee_current_position_name : arrCauser[2],
                    employee_nip : arrCauser[3]
                }
                localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                //console.log(arrCauser);
            }
        } catch (error) {}
    }

    componentWillUnmount(){
        this.approveBloc.detailChannel.unsubscribe()
        this.approveBloc.approveChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="saudara"/>

                            <Card className="pegawai-rightbar">
                                <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                    <CardBody>

                                        <CardTitle>Approve Data Saudara</CardTitle>
                                        {/* <CardSubtitle className="mb-3">
                                            Informasi Detail Data Anak
                                        </CardSubtitle> */}
                                        <hr />
                                        {
                                        this.state.history ?
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                
                                            </label>
                                            <Col md="5">
                                                <strong> Data Baru </strong>
                                            </Col>
                                            <Col md="4">
                                                <strong className="text-danger"> Data Lama </strong>
                                            </Col>
                                        </Row>
                                        : '' }
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_name !== "" ? this.state.detail.family_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_name !== "" ? this.state.history.family_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Induk Kependudukan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_number !== "" ? this.state.detail.family_identity_number : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_number !== "" ? this.state.history.family_identity_number : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Kartu Keluarga
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.familty_family_card_number !== "" ? this.state.detail.familty_family_card_number : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.familty_family_card_number !== "" ? this.state.history.familty_family_card_number : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Dalam Negeri / Luar Negeri
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_national !== "" ? this.state.detail.family_place_of_birth_national : '-'}</>
                                                    : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_national !== "" ? this.state.history.family_place_of_birth_national : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Negara Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_country_name !== "" ? this.state.detail.family_place_of_birth_country_name : '-'}</>
                                                    : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_country_name !== "" ? this.state.history.family_place_of_birth_country_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        {this.state.detail && this.state.detail.family_place_of_birth_country_uuid == '61b47307-167d-489f-bb6c-c1c9662acab3' ? (
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Provinsi Lahir
                                                </label>
                                                <Col md="5">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_identity_province_name !== "" ? this.state.detail.family_identity_province_name : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                                <Col md="4">
                                                    {
                                                        this.state.history ?
                                                            <>{this.state.history.family_identity_province_name !== "" ? this.state.history.family_identity_province_name : '-'}</>
                                                        : ""
                                                    }
                                                </Col>
                                            </Row>
                                        ) : (
                                            <small></small>
                                        )}       
                                        
                                        {this.state.detail && this.state.detail.family_place_of_birth_country_uuid == '61b47307-167d-489f-bb6c-c1c9662acab3' ? (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kota Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_city_name !== "" ? this.state.detail.family_place_of_birth_city_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_city_text !== "" ? this.state.history.family_place_of_birth_city_text : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kota
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_city_text !== "" ? this.state.detail.family_place_of_birth_city_text : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_city_text !== "" ? this.state.history.family_place_of_birth_city_text : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    )}       


                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_date_of_birth !== "" ? this.dateParse(this.state.detail.family_date_of_birth) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_date_of_birth !== "" ? this.dateParse(this.state.history.family_date_of_birth) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jenis Kelamin
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_gender_name !== "" ? (this.state.detail.family_gender_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_gender_name !== "" ? (this.state.history.family_gender_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jenis Pekerjaan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_spouse_job_type_name !== "" ? (this.state.detail.family_spouse_job_type_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_spouse_job_type_name !== "" ? (this.state.history.family_spouse_job_type_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        { (this.state.detail?.family_spouse_job_type == "1" || this.state.detail?.family_spouse_job_type == "2") ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="5">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_profession_pns_nip !== "" ? (this.state.detail.family_profession_pns_nip) : '-'}</>
                                                        : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                                <Col md="4">
                                                    {
                                                        this.state.history ?
                                                            <>{this.state.history.family_profession_pns_nip !== "" ? (this.state.history.family_profession_pns_nip) : '-'}</>
                                                        : ""
                                                    }
                                                </Col>
                                            </Row>
                                            : ""
                                        }
                                        { this.state.detail?.family_spouse_job_type == "3" &&
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Pekerjaan
                                                </label>
                                                <Col md="5">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_profession !== "" ? (this.state.detail.family_profession) : '-'}</>
                                                        : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                                <Col md="4">
                                                    {
                                                        this.state.history ?
                                                            <>{this.state.history.family_profession !== "" ? (this.state.history.family_profession) : '-'}</>
                                                        : ""
                                                    }
                                                </Col>
                                            </Row>
                                        }
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Alamat
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_address !== "" ? (this.state.detail.family_identity_address) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_address !== "" ? (this.state.history.family_identity_address) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Provinsi
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_province_name !== "" ? (this.state.detail.family_identity_province_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_province_name !== "" ? (this.state.history.family_identity_province_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kota/Kabupaten
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_city_name !== "" ? (this.state.detail.family_identity_city_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_city_name !== "" ? (this.state.history.family_identity_city_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kecamatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_district_name !== "" ? (this.state.detail.family_identity_district_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_district_name !== "" ? (this.state.history.family_identity_district_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Desa/Kelurahan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_village_name !== "" ? (this.state.detail.family_identity_village_name) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_village_name !== "" ? (this.state.history.family_identity_village_name) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kode Pos
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_postal_code !== "" ? (this.state.detail.family_identity_postal_code) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_postal_code !== "" ? (this.state.history.family_identity_postal_code) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Telepon
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_phone_number !== "" ? (this.state.detail.family_phone_number) : '-'}</>
                                                    : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_phone_number !== "" ? (this.state.history.family_phone_number) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Button 
                                                  color="success" 
                                                  type="submit"
                                                >
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to="/kepegawaian/home.html?saudara">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </AvForm>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan approval untuk data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?saudara'/>
                : null }
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);